import url from '@/creditflowresearch/infrastructure/url';
import staticUrls from '@finsight/urls/static';

const getIssuerMetaSchema = (pathname: string, issuerName: string) => ({
  '@type': 'ProfilePage',
  url: url.getUrl(pathname),
  name: `${ issuerName } Profile`,
  description: `View ${ issuerName } historical fixed income issuance and pricing profile here.`,
  keywords: [issuerName, 'bonds', 'fixed income issuance'],
  hasPart: {
    '@type': 'Dataset',
    name: issuerName,
    description: `View ${ issuerName }'s historical fixed income issuance and pricing profile here.`,
    license: staticUrls.getTermsOfUseUrl(),
  },
});

export default getIssuerMetaSchema;
